import type { ItemContextValue } from "./ItemContextValue"

export const defaultItemContextValue: ItemContextValue = {
  items: [],
  itemCount: 90,
  getIndexSize: () => 38,
  getIndexId: () => "-1",
  getIndexItem: () => undefined,
  getIdIndexRef: { current: () => 0 },
  updateIndexSize: () => {},
  defaultSize: 86, // the approximate size of a feed item
}
